const PreferenceCenter_getSelectedCountryOption = require("./PreferenceCenter_getSelectedCountryOption");

/**
 * @param preferenceCenter {HTMLElement}
 * @return {void}
 */
module.exports = function checkAllPreferenceCenterOptions(preferenceCenter) {
    document.querySelectorAll('input[type="checkbox"]').forEach(checkbox => {
        if (checkbox instanceof HTMLInputElement) {
            if (checkbox.name === "marketingSMSOptIn") {
                const country = PreferenceCenter_getSelectedCountryOption(preferenceCenter);
                if (country === "United States") {
                    checkbox.checked = true;
                }
            } else if (checkbox.name !== "marketingConsent") {
                checkbox.checked = true;
            }
        }
    });

    preferenceCenter.querySelectorAll('[name="unsubscribeAll"]').forEach(unsubscribeAllCheckbox => {
        unsubscribeAllCheckbox.checked = false;
    });
}
